import { Service } from './model'

export const isMgService = (service: string): boolean => service === Service.MG

export const isPfService = (service: string): boolean => service === Service.Pinkfile

export const isUloztoService = (service: string): boolean => service === Service.Ulozto
